import React from "react";
import { Routes, Route } from "react-router-dom";
import Form from "./pages/Form";
import Home from "./pages/Home";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/postulante" element={<Form />} />
    </Routes>
  );
};
export default App;
